export const ADMIN_PAGES = [
  ['/admin/dashboard', 'Admin Dashboard', 'Dashboard'],
  ['/admin/billing', 'Billing & Subscriptions', 'Billing & Subscriptions'],
  ['/admin/facilities', 'Facility administration', 'Facility administration'],
  ['/admin/users', 'Physician & Staff Management', 'Users & access'],
  ['/admin/invitations', 'Invitations', 'Invitations'],
  ['/admin/accounts', 'Account Status', 'Account status'],
  ['/admin/platform-admins', 'Platform Admin Management', 'Platform admins'],
  ['/admin/audit', 'Audit Logs', 'Audit trail'],
  ['/admin/templates', 'Master Templates', 'Master templates'],
  ['/admin/icd10', 'ICD-10 Releases', 'ICD-10 releases'],
  ['/admin/support', 'Support Requests', 'Support access'],
  ['/admin/health', 'System Health', 'System health'],
];
export const isAdminPath = path => path === '/admin' || path.startsWith('/admin/');
export const adminTabForPath = path => /^\/admin\/facilities\/\d+$/.test(path) ? 'Facility details' : ADMIN_PAGES.find(([url])=>url===path)?.[2] || 'Dashboard';
